<template>
<div class="chapter">
<div class="inner_page">
<div class="sgc-toc-title">Table of Contents</div>
<div class="sgc-toc-level-1">
<a href="#/Text/Chap_01#uPVwsKdMUTDcQXoIU2kE6R4">Through the Looking Ass</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/Chap_02#ugD4Xb8awzaWu7yw4pOVUg7">Introduction</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/Chap_03#u4eKEgfD9yx5mbIdJ4hXxtG">Texas</a>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_04#uAgQa2nrRqatbqGEmNygH2G" title="Link target outside of Sample">Traveling Medicine Man</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_05#u4F5vFOZAX3vjtD5x95NnF5" title="Link target outside of Sample">Introduction to Asses</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_06#uqPmmjTfBgmdF7qtKEjITDG" title="Link target outside of Sample">Some Advantages of Mules</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_07#uuXIQ9JGnkmR4PoXWnifPlE" title="Link target outside of Sample">Joshua T. Walker</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_08#uqtAv4ZNffdSRybD7z7topA" title="Link target outside of Sample">Mule Breeding</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_09#us8v6zElnCsf896lCWLRxRA" title="Link target outside of Sample">College Cowboy</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_10#uDuygvKyZdS3vmJjU3OCl4F" title="Link target outside of Sample">Jackass Out of Control</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_11#uBNURUdMx4TyCiSYgk2yQZ7" title="Link target outside of Sample">Tan My Hide</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_12#uHogiYCRP7MmOZ6UZRmipf5" title="Link target outside of Sample">The Crossing</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_13#uwI7MjVq4zRApPVrRbBKQWA" title="Link target outside of Sample">Gunther</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_14#utqeUJ8hstsQXDCLtldttwF" title="Link target outside of Sample">Lilly</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_15#umqXSUPejJib7PyTTzHxKdA" title="Link target outside of Sample">Jumping Jehoshaphats</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_16#uTkvksFmgfeoPnrKjUpBxG7" title="Link target outside of Sample">Everything that Kills Me Makes Me Feel Alive</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_17#uVSwpkQD7fTNjSGPMMD2T43" title="Link target outside of Sample">Duley</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_18#uHf7qttaKRsSK2axWfdAsU9" title="Link target outside of Sample">Blossom’s First Job</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_19#uzktIqC7OnvDIhQrdWzebOG" title="Link target outside of Sample">Equine Nomenclature</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_20#uOCNhvyxgmVU47Fb5RS3Do9" title="Link target outside of Sample">Maybell</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_21#uaDCCHynUKXUYXsTO8ACWD3" title="Link target outside of Sample">Aspen</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_22#ubYxUXiahkkPFelJjzak3x9" title="Link target outside of Sample">Mule Racing</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_23#uGKxK3m4ZYBvgZzNL4cwavE" title="Link target outside of Sample">Cro-Maggie</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_24#uPVtgwlUq9Aht5RWxFfuXqE" title="Link target outside of Sample">Zebadiah and Sexy</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_25#uS4OG3cWQZ72OSXptUcvb85" title="Link target outside of Sample">Jumping</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_26#uOMQKBT7x7NYers5XZoQfOF" title="Link target outside of Sample">Jackasses and Traditions: A Muletide Story</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Photos#uBoouiFEpf6MTUee4iwIpKD" title="Link target outside of Sample">Photos</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_27#uevaH4m96Nzg3voswueiHC2" title="Link target outside of Sample">Compost</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_28#uLPhzAbGFo4mPuFgaJqFEs3" title="Link target outside of Sample">Ship of Fools</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_29#uNWmWqFRZP6vCKGEvorZVg9" title="Link target outside of Sample">Kathy</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_30#uvzAEs5hPC3Hvo5aK82tGK5" title="Link target outside of Sample">The Dance</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_31#u5kyOQ8oRXuU7pQR47tZJ2B" title="Link target outside of Sample">Cancun Honeymoon</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_32#ubdUqKtIhWmjXNtBwnDzce8" title="Link target outside of Sample">Justice Served in Courthouse Wash</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_33#u4VIy7cTPx2ml7bLDysfV6G" title="Link target outside of Sample">Xcalak</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_34#ulnbNmJogyCOR4wq9XAfJFE" title="Link target outside of Sample">Rodeo Clown</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_35#uSGZwj7cGJmL8Dtkso3ODq8" title="Link target outside of Sample">Running with the Bulls</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_36#ucbDnvzatXgCttq9SjhfjrC" title="Link target outside of Sample">A Bum In La Paz</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_37#uPGcK4YpHruOpM3F55KxAh8" title="Link target outside of Sample">Wedding</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_38#upWxJudVpteiTVqfUH6CXLG" title="Link target outside of Sample">Hitchin’ Post</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_39#uUknJLq9RSlrLNfSV4Sh739" title="Link target outside of Sample">Rifle</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_40#unyNeM9AmrLJfyeEwxq5265" title="Link target outside of Sample">Loss of Dreams</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_41#uED6MBrGLHmSvhz5LvN8sW5" title="Link target outside of Sample">The True Value of Critters</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_42#uSbokrHXfSh4rK2mwyahBxE" title="Link target outside of Sample">Being Worthy of Bo</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_43#upFQFLi3CPKXvjoTGgg7sK7" title="Link target outside of Sample">Needle in a Hayburner</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_44#uhiKqJQNQliVGLFW2xtFjB8" title="Link target outside of Sample">Sanchez</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_45#uzZktuoRIZE9OQhHHtohNK5" title="Link target outside of Sample">Back to Texas</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_46#u5jZOvgNAKzF8rQ6bm4P2j5" title="Link target outside of Sample">Cedar Chopper</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_47#umEgSoPk2VtglzEjedAqtdG" title="Link target outside of Sample">Baby Acapulco’s</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_48#uJPh6j9ZprgA8wx6nTIEwE7" title="Link target outside of Sample">Huntin’ Guide</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_49#uSeLyw4GuQmdDDEkKdV2vPG" title="Link target outside of Sample">Take a Hike, Old Man</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Ack#uroDKLGMtL32jH9BpUnBRu3" title="Link target outside of Sample">Acknowledgements</span>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// TOC.vue?6c79ab29